import _ from 'lodash';
import React from 'react';
import DocBlock from 'components/DocBlock';
import { Bubble } from 'ctia-ui';

const NoDocsBubble = () => (
  <Bubble>No Supporting Documentation provided</Bubble>
);

const SupportDocsReadonly = ({ docs }) => {
  if (!docs || !docs.length) return <NoDocsBubble />;

  const filteredDocs = _.filter(docs, 'docId');

  if (!filteredDocs.length) return <NoDocsBubble />;

  return filteredDocs.map(doc => {
    return <DocBlock doc={doc} key={doc.docId} />;
  });
};

export default SupportDocsReadonly;



// WEBPACK FOOTER //
// ./src/components/SupportDocsReadonly.js